var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { IconButton } from "../../../../Atoms";
var CollapseIconCell = function (_a) {
    var collapseOpen = _a.collapseOpen;
    if (collapseOpen) {
        return (_jsx(IconButton, __assign({ "aria-label": "close" }, { children: _jsx(ExpandLessIcon, {}) })));
    }
    return (_jsx(IconButton, __assign({ "aria-label": "open" }, { children: _jsx(ExpandMoreIcon, {}) })));
};
export default React.memo(CollapseIconCell);
